import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { LexgosignService } from '@services/lexgosign.service';

@Injectable({ providedIn: 'root' })
export class LexgosignEnabledGuard implements CanActivate {
  constructor(
    private lexgosignService: LexgosignService,
    private router: Router
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.lexgosignService.isEnabled().pipe(
      map((enabled) => (enabled ? true : this.router.createUrlTree(['/intro']))),
      catchError(() => of(this.router.createUrlTree(['/intro'])))
    );
  }
}
